import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component, ElementRef,
  EventEmitter,
  Input, OnChanges, OnDestroy,
  Output, SimpleChanges,
  ViewChild
} from '@angular/core';

import { INotification } from '../../../shared/models/notification.model';

// eslint-disable-next-line @typescript-eslint/no-explicit-any, no-var
declare var jQuery: any;

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-ui-notifications-button',
    templateUrl: './notifications-button.component.html',
    styleUrls: ['./notifications-button.component.scss'],
    standalone: false
})

export class NotificationsButtonComponent implements AfterViewInit, OnChanges, OnDestroy {
  @ViewChild('notificationsContent') contentNotificationsEl: ElementRef;
  @ViewChild('notificationIcon') notificationIconEl: ElementRef;
  private popoverShown = false;

  @Input() notifications: INotification[];

  @Output() removeNotification = new EventEmitter<string>();
  @Output() clearNotifications = new EventEmitter();

  ngAfterViewInit() {
    // eslint-disable-next-line max-len
    const html = '<div class="popover popover-dispo notifications-popover" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>';

    jQuery('[data-toggle="popover"]').popover({
      content: this.contentNotificationsEl?.nativeElement,
      template: html
    }).on('hidden.bs.popover', () => {
      this.popoverShown = false;
    }).on('shown.bs.popover', () => {
      this.popoverShown = true;
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.changePopover(jQuery('[data-toggle="popover"]'), changes.notifications.currentValue?.length);
    if (!changes.notifications.firstChange && this.notificationsNumberIncreased(changes.notifications)) {
      this.toggleRinging();
    }
  }

  removeFromNotifications(notificationUUID: string) {
    this.removeNotification.emit(notificationUUID);
  }

  private toggleRinging() {
    if (!this.notificationIconEl?.nativeElement?.classList?.contains('ringing')) {
      this.notificationIconEl?.nativeElement?.classList.add('ringing');

      setTimeout(() => {
        this.notificationIconEl?.nativeElement?.classList.remove('ringing');
      }, 4000);
    }
  }

  private changePopover(popoverEl, notificationsNumber: number) {
    setTimeout(() => {
      if (!notificationsNumber) {
        popoverEl.popover('hide');
      }
      popoverEl.popover(notificationsNumber ? 'enable' : 'disable');
    }, 0)
  }

  private notificationsNumberIncreased(notifications): boolean {
    return notifications.previousValue.length < notifications.currentValue.length;
  }

  clickOutsideOfNotifications() {
    if (this.popoverShown) {
      jQuery('[data-toggle="popover"]').popover('hide');
    }
  }

  clearAllNotifications() {
    this.clearNotifications.emit();
  }

  ngOnDestroy() {
    jQuery('[data-toggle="popover"]').popover('hide');
  }

}
